/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-07 16:44:21
 * @LastEditors: changfeng
 * @LastEditTime: 2024-04-24 19:05:44
 */
import { Button, Divider, message, Modal } from "antd";
import facebookAvatar from "@/assets/logo/logo_fb.png";
import { fetchRemoveFacebookAuth, fetchFacebookSetting, FacebookAUthorization } from "@/api/modules/AdAccount";
import { Trans, useTranslation } from "react-i18next";

const ProFilesModal = (props: { open: boolean; onClose: () => void; data: any[]; onOkCallBack: () => void }) => {
	const { t } = useTranslation();
	const { open, onClose, data = [], onOkCallBack } = props;

	const handleAuth = () => {
		fetchFacebookSetting().then(res => {
			FacebookAUthorization({ AppId: res.data?.appId });
		});
	};

	const handleRemoveAuth = value => {
		Modal.confirm({
			title: t("account.profile.unlink.modal.title"),
			content: (
				<div>
					<Divider />
					<span style={{ fontSize: "1rem", lineHeight: "1.8rem" }}>
						<span>{t("account.profile.unlink.modal.text1")}</span>
						<span style={{ color: "#565BDD" }}>{value.name}</span>
						<span>{t("account.profile.unlink.modal.text2")}</span>
					</span>
					<ul className="effect">
						<li>
							<span style={{ fontSize: "0.875rem", lineHeight: "1rem" }}>{t("account.profile.unlink.modal.text.tip")}</span>
						</li>
					</ul>
				</div>
			),
			okText: t("account.profile.unlink.modal.text.button.ok"),
			closable: true,
			width: 720,
			okType: "danger",
			cancelText: t("action.button.cancel"),
			onOk() {
				fetchRemoveFacebookAuth({ id: value.id }).then(res => {
					if (res.code === 200) {
						message.success(t("account.profile.unlink.modal.text.remove.success"));
						onClose();
						onOkCallBack();
					}
				});
			},
			onCancel() {}
		});
	};
	return (
		<Modal
			open={open}
			width={600}
			title={t("account.profile.card1.modal.title")}
			closable
			onCancel={() => onClose()}
			footer={null}
		>
			{data &&
				data?.map(item => {
					return (
						<div className="profile_modal_item" key={item.name}>
							<div className="profile_modal_item_left">
								<div className="avatar">
									<img src={facebookAvatar} alt="" />
								</div>
								<div className="profile_modal_item_left_info">
									<span className="name">{item.name}</span>
									<span className="id">ID: {item.facebookUserId}</span>
								</div>
							</div>
							<div className="profile_modal_item_right">
								<Button className="unlink" onClick={() => handleRemoveAuth(item)}>
									{t("account.profile.card1.modal.button")}
								</Button>
							</div>
						</div>
					);
				})}
		</Modal>
	);
};

export default ProFilesModal;
